import React from 'react';

import { BaseResponse } from '../../../types/apiCompoundCommon';

export const helperHooks = {
  useHandleResponse<T,>(mutationCallback?:
    (response: BaseResponse<T>) => void) {
    return React.useCallback((data: BaseResponse<T>) => {
      const callback = !data.data.errors?.length
        ? mutationCallback
        : undefined;
      callback?.(data);
    }, [mutationCallback]);
  },
  useHandleResponseWithoutData<T,>(onResponseCallback?: () => void) {
    return React.useCallback((data: BaseResponse<T>) => {
      const callback = !data.data.errors?.length
        ? onResponseCallback
        : undefined;
      callback?.();
    }, [onResponseCallback]);
  },
};
